import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ICheckOutLabel } from '../../../core/models';
import { CheckoutService } from '../../../core/services/checkout.service';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';

@Component({
  selector: 'app-cart-checkout-credit-card-payment-complete',
  templateUrl: './cart-checkout-credit-card-payment-complete.component.html',
  styleUrls: ['./cart-checkout-credit-card-payment-complete.component.scss']
})
export class CartCheckoutCreditCardPaymentCompleteComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private checkoutService: CheckoutService,
    private languageTranslationService: LanguageTranslationService) {
    this.activatedRoute.queryParamMap.subscribe(params => {
      console.log(params);
      this.trackerId = params.get('trackerID') || '';
      console.log("normal checkout completion trackerid=" + this.trackerId);
    }
    );
  }

  trackerId: string = '';
  isComplete: boolean = false;
  acknowledgeNumber: string = '';
  isError: boolean = true;
  ngOnInit() {
    this.completeTxn();
    this.loadLanguageTranslationData();
  }
  async completeTxn() {
    if (this.trackerId) {
      var request = { "trackerId": this.trackerId };
      try {
        var paymentResponse = await this.checkoutService.completeCreditCardCheckout(request).toPromise();
        if (!paymentResponse.isError) {
          this.isError = false;
          this.acknowledgeNumber = paymentResponse.data;
        } else {
          this.isError = true;
        }
      }
      catch (e) {
      }
      this.isComplete = true;
    } else {
      this.isComplete = true;
    }
  }
  //#region Language Translation Section
  lblText: ICheckOutLabel;
  public checkOut = {
    submitedInfo1: 'Thank you for shopping with us.',
    submitedInfo2: 'Your order has been successfully placed.',
    continueShoppingLbl: 'Continue Shopping!',
    kawneerOrderLbl: 'Your KawneerDirect Order Number',
    kdLbl: 'KD',
    submitedInfo3: 'Sorry we are unable to process your order. Please try again.',
    submitedInfo4: 'If problem persists, please connect to Kawneer Admin',
    closeLbl: 'Close',
    surveyFeedbackLbl: 'Please provide feedback'
  };
  loadLanguageTranslationData() {
    //need to add remaining fields
    const controlNameList = [
      { controlName: "confirmOrderLbl" },
      { controlName: "confirmOrderCCLbl" },
      { controlName: "submitedInfo1" },
      { controlName: "submitedInfo2" },
      { controlName: "submitedInfo3" },
      { controlName: "submitedInfo4" },
      { controlName: "continueShoppingLbl" },
      { controlName: "kawneerOrderLbl" },
      { controlName: "kdLbl" },
      { controlName: "closeLbl" },
      { controlName: "surveyFeedbackLbl" }
    ];
    const componentName = "checkout";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.lblText = response[response.length - 1];
    }
  }
  //#endregion

}
